import { tokens } from '@datacamp/waffles/tokens';
import { useLayoutEffect, useState } from 'react';
export const useIsSmallScreen = () => {
  const [isMobile, setIsMobile] = useState(false);
  useLayoutEffect(() => {
    const mediaQ = window.matchMedia("(max-width: ".concat(tokens.breakpoints.small, ") or (max-height: ").concat(tokens.breakpoints.small, ")"));
    setIsMobile(mediaQ.matches);
    const handleMediaQueryChange = event => {
      setIsMobile(event.matches);
    };
    mediaQ.addEventListener('change', handleMediaQueryChange);
    return () => {
      mediaQ.removeEventListener('change', handleMediaQueryChange);
    };
  }, []);
  return isMobile;
};